import React from "react";

const ProductContext = React.createContext(null);
ProductContext.displayName = "ProductContext";

export default ProductContext;
